import { Box, BoxProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import React, { ReactNode } from "react";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

type ScrollBarProps = {
  children: ReactNode;
  noWrap?: boolean;
  enableHorizontalScroll?: boolean;
} & BoxProps &
  SystemProps<Theme>;

const ScrollArea: React.FC<ScrollBarProps> = ({ children, sx, ...others }) => {
  const { systemSx, rest } = splitSystemProps(others);
  return (
    <Box
      {...rest}
      sx={mergeSx(
        {
          overflowY: "overlay",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
          ...systemSx,
          height: systemSx.height ?? "100vh",
        },
        sx
      )}
    >
      {children}
    </Box>
  );
};

export { ScrollArea };
